import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import module from 'app/modules/management-of-change/moc.module';
import { ManagementOfChangeService } from '../../services/management-of-change.service';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { MocApprovalStatus, MocStatus } from '../../model';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
  selector: 'app-manually-check',
  standalone: true,
  imports: module,
  templateUrl: './manually-check.component.html',
  styleUrl: './manually-check.component.scss'
})
export class ManuallyCheckComponent {
  public mocStatus = MocStatus
  public mocApprovalStatus = MocApprovalStatus

  selectedWells: string[] = [];
  mocRecordDetails: any[] = []

  constructor(
    public dialogRef: MatDialogRef<ManuallyCheckComponent>,
    @Inject(MAT_DIALOG_DATA) public failureNotificationRecord: any,
    private mocService: ManagementOfChangeService,
    private _fuseConfirmationService: FuseConfirmationService,
  ) { }

  ngOnInit() {
    if(this.failureNotificationRecord.mocRecordIds.length > 0){
      this.selectedWells = this.failureNotificationRecord.mocRecordIds
    }

    this.mocService.getMocAppTrackingManualById(this.failureNotificationRecord.id).subscribe((record) => {
      this.mocRecordDetails = record.data.mocRecordDetails
    })
  }

  submitMocAppTracking() {
    // Open the confirmation dialog
    const confirmation = this._fuseConfirmationService.open({
      title: 'Confirmation MOC record',
      message: 'Are you sure you want to refer MOC record to Application Tracking record?',
      actions: {
        confirm: {
          color: 'primary',
          label: 'Confirm',
        },
      },
    });

    confirmation.afterClosed().subscribe((result) => {
      // If the confirm button pressed...
      if (result === 'confirmed') {
        const payload = {
          id: this.failureNotificationRecord.id,
          modRecordIds: this.selectedWells
        }

        this.mocService.manualAppTrackClose(payload).subscribe((response) => {
          this.dialogRef.close('success')
        });
      }
    })

  }

  onCheckboxChange(event: Event, id: string) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedWells.push(id);
    } else {
      this.selectedWells = this.selectedWells.filter(x => x !== id);
    }
  }

  handleFormatDate(dateString: string, withTime) {
    return handleFormatDate(dateString, withTime)
  }
}
